export const COLLECTION_LIST_LAYOUTS = [
    "news-grid",
    "cards",
    "featured",
];
export const collectionListSchema = {
    componentId: "CollectionList",
    scalarSlots: [
        {
            key: "collectionId",
            label: "Collection",
            type: "select",
            optionsSource: "collections",
        },
        {
            key: "layout",
            label: "Layout",
            type: "select",
            options: [
                { value: "news-grid", label: "News grid" },
                { value: "cards", label: "Cards with pictures" },
                { value: "featured", label: "One featured, the rest beneath" },
            ],
        },
        {
            key: "sortField",
            label: "Order by",
            type: "select",
            optionsSource: "collection-fields",
            dependsOn: "collectionId",
        },
        {
            key: "sortDirection",
            label: "Direction",
            type: "select",
            options: [
                { value: "desc", label: "Newest first" },
                { value: "asc", label: "Oldest first" },
            ],
        },
        { key: "limit", label: "How many", type: "number" },
        { key: "viewAllLabel", label: "View-all label", type: "text" },
    ],
    mediaSlots: [],
    repeatSlots: [
        {
            // A repeat slot, not a JSON scalar. An Editor composing "only entries
            // whose source is Business Wire" is composing STRUCTURE, and the editor
            // already knows how to add, remove and reorder rows of fields — asking
            // them to type JSON into a text box would be asking them to hand-write a
            // data structure the product otherwise builds for them.
            key: "filters",
            label: "Filters",
            itemLabel: "Filter",
            scalarSlots: [
                {
                    key: "field",
                    label: "Field",
                    type: "select",
                    optionsSource: "collection-fields",
                    dependsOn: "collectionId",
                },
                {
                    key: "op",
                    label: "Condition",
                    type: "select",
                    options: [
                        { value: "eq", label: "is" },
                        { value: "neq", label: "is not" },
                        { value: "contains", label: "contains" },
                        { value: "gt", label: "is after" },
                        { value: "lt", label: "is before" },
                        { value: "set", label: "has a value" },
                        { value: "unset", label: "is empty" },
                    ],
                },
                { key: "value", label: "Value", type: "text" },
            ],
            mediaSlots: [],
        },
    ],
};
/** Read a placed block into the data its renderer takes. */
export function collectionListDataFrom(block) {
    const s = block.scalars ?? {};
    const layout = COLLECTION_LIST_LAYOUTS.includes(s.layout)
        ? s.layout
        : "news-grid";
    const rows = block.repeats?.filters ?? [];
    const filters = [];
    for (const row of rows) {
        const field = row.scalars?.field ?? "";
        const op = row.scalars?.op ?? "";
        // A half-composed row is DROPPED, not rendered as a filter that matches
        // nothing. An Editor mid-edit should not empty the list they are looking at.
        if (!field || !op)
            continue;
        filters.push({ field, op, value: row.scalars?.value ?? "" });
    }
    const limit = Number.parseInt(s.limit ?? "", 10);
    return {
        collectionId: s.collectionId || "",
        layout,
        sortField: s.sortField || "",
        sortDirection: s.sortDirection === "asc" ? "asc" : "desc",
        limit: Number.isFinite(limit) && limit > 0 ? limit : 0,
        viewAllLabel: s.viewAllLabel || "",
        filters,
    };
}
//# sourceMappingURL=collection-list.js.map